import Vue from "vue";

export default {
  set(state, data) {
    var dataKeys = [];

    for (let key in data) {
      dataKeys.push(key);
      Vue.set(state, key, data[key]);
    }

    for (let key in state) {
      if (!dataKeys.some((x) => x === key)) Vue.set(state, key, null);
    }
  },
  patch(state, data) {
    for (let key in data) Vue.set(state, key, data[key]);
  },
};
